import ContentModel from "./ContentModel";
import SaveModel from "./SaveModel";
import { ScalingModel, ColorPalette, Fonts } from "./UIModels";

/**
 * Settings and other properties that we want avalible across the game we can now just define in this file
 * It allows us access to the properties at runtime, and we rarely change game setting without rebuild a project
 * so this will reduce the amount of errors when parsing a JSON file, spelling, missing parameters, wrong types.
 *
 * @category models
 * @export
 * @class GameModel
 */
export default class Model {
  public static language: string = "en";
  private _save: SaveModel = new SaveModel();
  public content: ContentModel = new ContentModel();
  public scale: ScalingModel = new ScalingModel();
  public colours: ColorPalette = new ColorPalette();
  public fonts: Fonts = new Fonts();

  /**
   * this SceneID in which to boot first.
   *
   * @type {string}
   * @memberof GameModel
   */
  public readonly startScene: string = "SplashScene"; // confirm this is loaded in the index.ts game config, the key will be what is defined in the constructor of that class.

  /**
   * global debug flag - should debugging options be enabled
   *
   * @type {boolean}
   * @memberof GameModel
   */
  public readonly debug: boolean = true;

  /**
   * a tracking system to enable by default and prioritise loading.
   *
   * @type {TrackingType}
   * @memberof GameModel
   */
  public readonly trackingEnabled: boolean = true;

  /**
   * get the same model, I've made this a getter as to allow future functionallity.
   *
   * @readonly
   * @memberof GameModel
   */
  get save(): SaveModel {
    return this._save;
  }

  /**
   * set the save model.
   *
   * @memberof GameModel
   */
  set save(save: SaveModel) {
    this._save = save;
  }
}
